import { Card } from '@/components/Bicester';
import React from 'react';
import ServiceInfo from '@/views/SiteService/components/ServiceInfo';
import { fetchEditSa, fetchSaInfo } from '@/services/subscribe/sa';
import { defaultDetailInfo, saDetailSchema } from '../Sa/constants';
import { SubscribeServiceStatus } from '../Manage/constants';
import { useRequest } from 'ahooks';
import { fetchSubscribeInfoSurplus } from '@/services/subscribe';
import { SUBSCRIBE_OPTION } from '../constants';

const SaInfo = () => {
  // 预约时间段和预约人数
  const {
    run: getSubscribeSurplus,
    data: subscribeSurplus,
    loading: subscribeSurplusLoading,
  } = useRequest(fetchSubscribeInfoSurplus, {
    manual: true,
    formatResult(response) {
      return {
        time_slot:
          response?.time_slot?.map((time) => {
            return {
              value: time?.number,
              label: time?.time_slot,
            };
          }) || [],
        content: new Array(Number(response?.content || 0)).fill(null).map((value, index) => {
          return {
            value: `${index + 1}`,
            label: `${index + 1}人`,
          };
        }),
      };
    },
  });

  return (
    <ServiceInfo
      basicLoading={subscribeSurplusLoading}
      defaultServiceInfo={defaultDetailInfo}
      serviceSchema={saDetailSchema}
      fetchInfo={fetchSaInfo}
      fetchEdit={fetchEditSa}
      getDefaultInfo={(data) => {
        getSubscribeSurplus(data?.shopping_village, data?.subscribe_date, SUBSCRIBE_OPTION.SA);
        return {
          sa_status: data?.sa_status,
          number: data?.number,
          content: data?.content,
          remark: data?.remark,
          member_id: data?.member_id,
        };
      }}
      getSubmitData={(id, values) => Object.assign({}, values, { id })}
      serviceInfo={({ formik, infoData, isEdit }) => (
        <>
          <Card.Input
            notEditable
            label="服务状态"
            formKey="sa_status"
            inputType="map"
            map={SubscribeServiceStatus}
          />
          <Card.Picker
            isEdit={isEdit}
            label="预约时间段"
            formKey="number"
            pickerData={subscribeSurplus?.time_slot}
            cleanable={false}
          />
          <Card.Picker
            isEdit={isEdit}
            label="预约人数"
            formKey="content"
            pickerData={subscribeSurplus?.content}
            cleanable={false}
          />
        </>
      )}
    />
  );
};
export default SaInfo;
